import { useSelector } from 'react-redux'
import { useState } from 'react'
import { App } from 'antd'
import { endOfMonth } from '../../../config/dayjsConfig'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { autoDownload } from '../../../utils/helpers'
import { fetchLoanExport } from '../service/loanService'
import loanQueryKeys from './loanQueryKeys'
import { investmentsPageSelector } from '../../../redux/pages/investments/selectors'

export const useLoanExport = (isExisting: boolean) => {
  const { message } = App.useApp()
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario: { id: budgetingScenarioId } = {} } = useSelector(filtersSelector)
  const { date } = useSelector(investmentsPageSelector)
  const [isLoading, setIsLoading] = useState(false)

  const handleExport = async () => {
    setIsLoading(true)
    try {
      const dateString = endOfMonth(date)
      const data = await fetchLoanExport(
        loanQueryKeys.summary({
          companyId,
          date: dateString,
          isExisting,
          budgetingScenarioId
        })[0]
      )
      autoDownload(`loan-export-${dateString}.xlsx`, data)
    } catch (err) {
      message.error('Failed to download file')
    } finally {
      setIsLoading(false)
    }
  }

  return { download: handleExport, isLoading }
}
